"use client";
import {
  useEffect,
  useState,
  useRef,
  useMemo,
  HtmlHTMLAttributes,
} from "react";
import Link from "next/link";
// import Image from "next/image";
import { Carousel } from "antd";
// import FSC from "@/app/assets/product/FSC.svg";
// import BEC from "@/app/assets/product/BEC.svg";
// import GreenGuard from "@/app/assets/product/GreenGuard.svg";
import Eco from "@/app/assets/eco/EcoLeaf.svg";
import { RateCustom } from "./RateCustom";
import useMobileDetect from "@/hooks/useMobileDetect";
import ImageWithSkeleton from "./ImageWithSkeleton";
import {
  changeUrl,
  preloadImage,
  handleUrlSpecialChar,
  throttle,
  handleImgUrl,
} from "@/utils/tools";
import { Numeric } from "@/app/components/common/Numeric";
import { CarouselEffect } from "antd/es/carousel";

import Global from "@/utils/global";
import "./style/ProductItemCard.css";
import Image from "next/image";
import { calc } from "antd/es/theme/internal";

type CertificateProps = {
  icon: string;
  width: number;
};

export type ProductItemCardProps = {
  product: string;
  navBgIconSize?: number;
  navIconSize?: number;
  container?: string;
  img?: string[];
  currentPrice?: number;
  originalPrice?: number;
  ratingNum?: number;
  remarkNum?: number;
  isRating?: boolean;
  isIcon?: boolean;
  iconSize?: number;
  certificate?: Array<CertificateProps>;
  key?: string;
  spuId?: string;
  type?: number;
  linkUrl?: string;
  marginTitleTop?: string;
  contentHeight?: string;
  productItems?: Array<any>;
  idx?: number;
  category?: string;
  spuCode?: string;
  cardType?: string;
  newProduct?: boolean;
  blackFriday?: boolean;
  showSkuItems?: boolean;
  showExperienceScore?: boolean;
};

export type ProductSkuItemType = {
  id: string;
  itemName: string;
  images: Array<{ whiteBackPic: Array<string> }>;
  selectFlag: boolean;
  spuPicList: Array<string>;
  salePrice: number;
  originPrice: number;
  itemCode: string;
  detailUrl: string;
  // 是否显示折扣
  saleFlag?: boolean
};

export const ProductItemCard: React.FC<ProductItemCardProps> = ({
  idx,
  category = "",
  img = [""],
  spuCode = "",
  // width = 247,
  // height = 247,
  isRating = true,
  isIcon = false,
  iconSize = 34,
  spuId = "",
  type = 1,
  ratingNum = 0,
  remarkNum = 0,
  navBgIconSize = "19%",
  navIconSize = 26,
  linkUrl = "",
  marginTitleTop = "mt-16",
  contentHeight = "",
  productItems = [],
  currentPrice = 0,
  originalPrice = 0,
  cardType = "",
  newProduct,
  blackFriday,
  showSkuItems,
  showExperienceScore,
  ...props
}) => {
  const [effect, setEffect] = useState<CarouselEffect>("scrollx"); // 控制切换效果
  const [autoSwitching, setAutoSwitching] = useState(false); // 控制自动切换状态
  // 轮播图片移动的下标位置
  const [carouselIndex, setCarouselIndex] = useState(0);
  // 图片的下标
  const carouselRef = useRef<any>(null);
  // 商品的售价
  const [productItemSalePrice, setProductItemSalePrice] =
    useState<number>(currentPrice);
  // 商品的原价
  const [productItemOriginalPrice, setProductItemOriginalPrice] =
    useState<number>(originalPrice);
  // 是否显示商品折扣
  const [isSaleFlag, setIsSaleFlag] = useState(productItems[0]?.saleFlag)
  //
  const [pIdx, setPIdx] = useState(0);
  // 商品的sku
  // if(productItems.length) {
  //   productItems[0].selectFlag = true
  // }
  const [productSkuList, setProductSkuList] =
    useState<ProductSkuItemType[]>(productItems);
  const [imgList, setImgList] = useState<string[]>(img);
  const isMobile = useMobileDetect();
  const productItemCardRef = useRef<any>(null);

  let isClickValue = false;

  useEffect(() => {
    const list = productItems.map((item, idx) => {
      if (idx === 0) {
        item.selectFlag = true;
      } else {
        item.selectFlag = false;
      }
      let spuPicList = [];
      // 白底图1张
      if (
        item?.images?.whiteBackPic &&
        item?.images?.whiteBackPic?.length > 0
      ) {
        spuPicList.push(item?.images?.whiteBackPic[0]);
      }
      // 场景图2张
      if (item?.images?.scenePic && item?.images?.scenePic?.length > 1) {
        spuPicList.push(item?.images?.scenePic[0]);
        spuPicList.push(item?.images?.scenePic[1]);
      }
      // 细节图1张
      if (item?.images?.detailPic && item?.images?.detailPic?.length > 0) {
        spuPicList.push(item?.images?.detailPic[0]);
      }
      // 尺寸图1张
      if (
        item?.images?.measurementPic &&
        item?.images?.measurementPic?.length > 0
      ) {
        spuPicList.push(item?.images?.measurementPic[0]);
      }

      item["spuPicList"] = spuPicList;

      return item;
    });
    setProductSkuList(list);
  }, []);

  // useEffect(() => {
  //   setImgList(img);
  //   setProductItemSalePrice(currentPrice);
  //   setProductItemOriginalPrice(originalPrice);
  // }, []);

  useEffect(() => {
    // img?.forEach((item, idx) => {
    //   if (idx !== 0) {
    //     setTimeout(() => {
    //       preloadImage(Global.imageUrl! + handleUrlSpecialChar(item));
    //     }, 200);
    //   }
    // });
  }, []);

  // 通过 ref 调用 Carousel 的 next() 方法
  const goToNext = throttle((index: number) => {
    setTimeout(() => {
      if (carouselRef.current) {
        // carouselRef.current.next(); // 调用 next() 方法切换到下一项
        carouselRef.current.goTo(index || 1);
      }
    }, 100);
  }, 500);

  // 通过 ref 调用 Carousel 的 next() 方法
  const goToPrev = throttle((index: number) => {
    setTimeout(() => {
      if (carouselRef.current) {
        // carouselRef.current.prev(); // 调用 next() 方法切换到下一项
        carouselRef.current.goTo(index || 0);
      }
    }, 100);
  }, 500);

  useEffect(() => {
    if (autoSwitching) {
      setTimeout(() => {
        !isClickValue && goToNext(1);
      }, 100);
    } else {
      setTimeout(() => {
        !isClickValue && goToPrev(0);
      }, 100);
    }
  }, [autoSwitching]);

  const smallSkuImgNum = useMemo(() => {
    if (
      productItemCardRef &&
      productItemCardRef.current &&
      productItemCardRef.current.offsetWidth
    ) {
      return Math.floor((productItemCardRef.current.offsetWidth - 16) / 36);
    } else {
      return 5;
    }
  }, [productItemCardRef.current]);

  const setProductItemSelectFlag = (option: ProductSkuItemType, idx: number) => {
    const _productSkuList = [...productSkuList];
    const _productSkuList_temp = _productSkuList.map((item, idx) => {
      if (option?.itemCode === item?.itemCode) {
        // console.log("itemitemitem---", item);
        // spu图片选择
        item["selectFlag"] = true;
        // 重置轮播图下标
        setCarouselIndex(0);
        carouselRef.current.goTo(0);
        // 设置价格
        setProductItemSalePrice(item?.salePrice);
        setProductItemOriginalPrice(item?.originPrice);
        // 设置折扣
        setIsSaleFlag(item?.saleFlag)
        // 设置选择的sku图片
        setImgList([...option?.spuPicList]);

      } else {
        item["selectFlag"] = false;
      }
      return item;
    });
    setProductSkuList(_productSkuList_temp);
    setPIdx(idx)
  };

  const _renderDivider = (amount: number) => {
    let temp = [];
    for (let i = 0; i < 6; i++) {
      temp.push(
        <div
          key={i}
          style={{
            width: "calc(100% / 6)",
            height: 3,
            backgroundColor: amount >= i + 1 ? '#402C22' : 'rgba(64, 44, 34, 0.2)',
            marginRight: i === 5 ? 0 : 4,
          }}
        />,
      );
    }

    return <div className="flex w-[100%] mr-[12px]">{temp.map((item) => item)}</div>;
  };

  const _renderFeature = (score1: number, score2: number, score3: number) => {
    return (
      <div style={{ marginTop: '14px', width: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <iconpark-icon
            name="Skin-friendly"
            icon-id="Skin-friendly"
            size="2rem"
          />
          <div style={{ marginLeft: '4px', display: 'flex', alignItems: 'center', width: '100%', }}>
            <div
              style={{ minWidth: '70px', marginRight: '6px', fontSize: '11px', textWrap: 'nowrap' }}
            >
              Skin-friendly
            </div>
            {_renderDivider(score1)}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
          <iconpark-icon name="Fabric" icon-id="Fabric" size="2rem" />
          <div style={{ marginLeft: '4px', display: 'flex', width: '100%', alignItems: 'center' }}>
            <div style={{ minWidth: '70px', marginRight: '6px', fontSize: '11px' }}>Softness</div>
            {_renderDivider(score2)}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
          <iconpark-icon
            name="Breathability"
            icon-id="Breathability"
            size="2rem"
          />
          <div style={{ marginLeft: '4px', display: 'flex', width: '100%', alignItems: 'center' }}>
            <div style={{ minWidth: '70px', marginRight: '6px', fontSize: '11px' }}>
              Resilience
            </div>
            {_renderDivider(score3)}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`${props?.container ?? "w-180 lg:w-247"} ProductItemCard product_item_bravve relative`}
      data-product-id={spuCode}
      data-spu-id={spuId}
      data-product-name={props.product}
      data-product-category={category}
      data-product-price={currentPrice}
      data-product-idx={idx}
      data-content-id={idx}
      data-content-position={spuCode}
      data-content-name={props.product}
      ref={productItemCardRef}
    >
      <Link
        href={changeUrl(productSkuList[pIdx]?.detailUrl || linkUrl)}
        target="_blank"
        onClick={(e) => {
          // @ts-ignore
          window.gtag("event", "item_click", {
            spu_id: spuId,
            spu_code: spuCode,
            timestamp: Date.now(),
          });
        }}
      >
        <div
          style={{ position: "relative" }}
          onMouseLeave={(e) => {
            if (carouselIndex === 0 || carouselIndex === 1) {
              !isClickValue && setEffect("fade"); // 切换为渐变效果
              setAutoSwitching(false); // 停止切换状态
            }
          }}
          onMouseEnter={(e) => {
            if (carouselIndex === 0 || carouselIndex === 1) {
              !isClickValue && setEffect("fade"); // 切换为渐变效果
              setAutoSwitching(true); // 开启切换状态
            }
          }}
        >
          {/* 左箭头 */}
          {imgList.length > 1 && !isMobile && (
            <div
              style={{
                position: "absolute",
                zIndex: 9,
                top: "50%",
                marginTop: `calc(-${navBgIconSize} / 2)`,
                width: navBgIconSize,
                height: navBgIconSize,
                maxWidth: "36px",
                maxHeight: "48px",
              }}
              onClick={(e) => {
                // isClickValue = true
                carouselRef.current.prev();
                e.preventDefault();
              }}
              onMouseEnter={(e) => {
                setEffect("scrollx"); // 切换为左右滑动效果
              }}
              onMouseLeave={(e) => {
                setEffect("fade"); // 切换为渐隐效果
              }}
            >
              <div
                className="navShow"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              >
                <iconpark-icon
                  icon-id="left"
                  size={`${navIconSize}`}
                  name="left"
                  color={"#402C22"}
                ></iconpark-icon>
              </div>
            </div>
          )}
          <Carousel
            key={imgList[0]}
            dots={false}
            ref={carouselRef}
            effect={effect}
            speed={500}
            // lazyLoad="ondemand"
            easing="ease-in-out"
            beforeChange={(currentSlide, nextSlide) => {
              setTimeout(() => {
                setCarouselIndex(nextSlide);
              }, 550);
            }}
          // style={{ width: "100%"}}
          >
            {imgList &&
              imgList.map(
                (item, idx) => (
                  <ImageWithSkeleton
                    key={item + idx}
                    idx={idx}
                    src={Global.imageUrl! + handleUrlSpecialChar(item)}
                    width={247}
                    height={247}
                    alt={props.product}
                    className="rounded-sm"
                  />
                ),
                // <Image
                //   key={item}
                //   src={Global.imageUrl! + handleUrlSpecialChar(item)}
                //   width={247}
                //   height={247}
                //   sizes="100vw"
                //   className="h-auto w-full rounded bg-bravve-bg-100"
                //   alt={props.product}
                // />
              )}
          </Carousel>
          <div className="mx-3">
            <div className="navShow absolute bottom-0 flex h-3 w-[99%] items-center bg-[#dbdbdb] text-white">
              {imgList && imgList.length > 0
                ? imgList.map((item, index) => {
                  return (
                    <div
                      key={index + "line_point"}
                      style={{ width: `calc(100% / ${imgList.length})` }}
                      className={`${index == carouselIndex ? "bg-[#222]" : ""} h-full`}
                    >
                      {/* {carouselIndex} */}
                    </div>
                  );
                })
                : false}
            </div>
          </div>
          {/* 右箭头 */}
          {imgList.length > 1 && !isMobile && (
            <div
              style={{
                position: "absolute",
                zIndex: 9,
                right: 0,
                top: "50%",
                marginTop: `calc(-${navBgIconSize} / 2)`,
                width: navBgIconSize,
                height: navBgIconSize,
                maxWidth: "36px",
                maxHeight: "48px",
              }}
              onClick={(e) => {
                // isClickValue = true
                carouselRef.current.next();
                e.preventDefault();
              }}
              onMouseEnter={(e) => {
                setEffect("scrollx"); // 切换为左右滑动效果
              }}
              onMouseLeave={(e) => {
                setEffect("fade"); // 切换为左右渐隐效果
              }}
            >
              <div
                className="navShow"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              >
                <iconpark-icon
                  icon-id="right"
                  size={`${navIconSize}`}
                  name="right"
                  color={"#402C22"}
                ></iconpark-icon>
              </div>
            </div>
          )}
        </div>
      </Link>
      {type === 1 ? (
        <div className={contentHeight} style={{ width: "100%" }}>
          <Link
            href={changeUrl(productSkuList[pIdx]?.detailUrl || linkUrl)}
            target="_blank"
            onClick={(e) => {
              // @ts-ignore
              window.gtag("event", "item_click", {
                spu_id: spuId,
                spu_code: spuCode,
                timestamp: Date.now(),
              });
            }}
          >
            {/* eco标签 */}
            {/* <div className="absolute left-10 top-0 flex flex-col items-end p-10">
              <Eco width={22} alt="Eco" />
            </div> */}
            <div className="absolute right-10 top-0 flex flex-col items-end p-10">
              {/* 黑色星期五标签 */}
              {blackFriday ? (
                <div className="text-13 flex h-22 w-88 items-center justify-center rounded-xs bg-[linear-gradient(to_right,#402c22_70%,#c31010_100%)] text-white">
                  Black Friday
                </div>
              ) : // 折扣标签
                isSaleFlag && productItemSalePrice < productItemOriginalPrice ? (
                  <div className="text-13 mb-10 flex h-22 w-70 items-center justify-center rounded-xs bg-error-100 text-white">
                    {parseFloat(
                      (
                        ((productItemOriginalPrice - productItemSalePrice) /
                          productItemOriginalPrice) *
                        100
                      ).toFixed(0),
                    )}
                    % OFF
                  </div>
                ) :
                  null}
            </div>

            <h3
              className={`productName text-16 mt-16 line-clamp-2 min-h-42 break-words text-bravve-100 ${marginTitleTop}`}
            >
              {/* NEW标签 */}
              {newProduct ? (
                <span className="mr-7 inline-block h-18 w-36 items-center justify-center rounded-[1px] bg-bravve-100 text-center text-[13px] leading-[18px] text-white">
                  New
                </span>
              ) : (
                false
              )}
              {props.product}
            </h3>
            <div className="mt-4">
              <span className={`text-18 font-medium`}>
                <Numeric
                  value={productItemSalePrice}
                  className={`${isSaleFlag && productItemSalePrice < productItemOriginalPrice ? "text-error-100" : "text-bravve-100"}`}
                // className={`"text-bravve-100"}`}
                />
              </span>
              {
                isSaleFlag && productItemSalePrice < productItemOriginalPrice ?
                  <span className="ml-6 text-bravve-sub-100 line-through">
                    <Numeric value={productItemOriginalPrice} className="text-14" />
                  </span>
                  :
                  null
              }
            </div>
            <div className="flex">
              {isRating && ratingNum && remarkNum ? (
                <RateCustom value={ratingNum} />
              ) : null}
              {isRating && remarkNum ? (
                <span className="ml-6 text-bravve-sub-100">{remarkNum}</span>
              ) : null}
            </div>
          </Link>
          {
            // @ts-ignore
            cardType == "PRODUCT_COLLECTION" && showExperienceScore ? _renderFeature(productSkuList[pIdx]?.experienceScore?.["Skin-friendly"] || 0, productSkuList[pIdx]?.experienceScore?.Softness || 0, productSkuList[pIdx]?.experienceScore?.Resilience || 0) : null
          }
          {/* 增加体验分和sku显隐的判断 */}
          {
            cardType != "PRODUCT_COLLECTION" || (cardType == "PRODUCT_COLLECTION" && showSkuItems) ? <div className="mt-14 flex h-40 items-center gap-4">
              {productSkuList && productSkuList.length > 0
                ? productSkuList.map((option: any, index: number) => {
                  if (isMobile) {
                    if (index > 2) {
                      return null;
                    }
                    if (index === 2) {
                      return (
                        <Link
                          key="sku-more"
                          className="ml-4 flex items-center"
                          href={changeUrl(productSkuList[pIdx]?.detailUrl || linkUrl)}
                          target="_blank"
                          onClick={() => {
                            // @ts-ignore
                            window.gtag("event", "item_click", {
                              items: JSON.stringify([
                                {
                                  id: spuCode,
                                  name: props.product,
                                  brand: "Bravve - more",
                                  category: category, // 商品类别
                                  variant: productSkuList[pIdx]?.detailUrl || linkUrl,
                                  price: productItemSalePrice,
                                  list_position: index,
                                },
                              ]),
                              ...{
                                id: spuCode,
                                name: props.product,
                                brand: "Bravve - more",
                                category: category, // 商品类别
                                variant: productSkuList[pIdx]?.detailUrl || linkUrl,
                                price: productItemSalePrice,
                                list_position: index,
                              },
                            });
                          }}
                        >
                          <span className="text-base leading-22 text-bravve-sub-100">
                            +More
                          </span>
                        </Link>
                      );
                    }
                  } else {
                    if (!smallSkuImgNum) {
                    } else {
                      if (index < smallSkuImgNum - 2) {
                      } else {
                        if (index === smallSkuImgNum - 2) {
                          return (
                            <Link
                              key="sku-more"
                              className="ml-4 flex items-center"
                              href={changeUrl(productSkuList[pIdx]?.detailUrl || linkUrl)}
                              target="_blank"
                              onClick={() => {
                                // @ts-ignore
                                window.gtag("event", "item_click", {
                                  items: JSON.stringify([
                                    {
                                      id: spuCode,
                                      name: props.product,
                                      brand: "Bravve - more",
                                      category: category, // 商品类别
                                      variant: productSkuList[pIdx]?.detailUrl || linkUrl,
                                      price: productItemSalePrice,
                                      list_position: index,
                                    },
                                  ]),
                                  ...{
                                    id: spuCode,
                                    name: props.product,
                                    brand: "Bravve - more",
                                    category: category, // 商品类别
                                    variant: productSkuList[pIdx]?.detailUrl || linkUrl,
                                    price: productItemSalePrice,
                                    list_position: index,
                                  },
                                });
                              }}
                            >
                              <span className="text-base leading-22 text-bravve-sub-100">
                                +More
                              </span>
                            </Link>
                          );
                        }
                        return null;
                      }
                    }
                  }
                  return (
                    <div
                      key={option.itemCode + "skuItem"}
                      style={{
                        border: `1px solid ${option?.selectFlag ? "#402C22" : "#402C221A"}`,
                        flex: "0 0 3.6rem",
                        height: "3.6rem",
                        overflow: "hidden",
                        position: "relative",
                        boxSizing: "content-box",
                        verticalAlign: "top",
                      }}
                      onClick={(e) => {
                        setProductItemSelectFlag(option, index);
                        e.stopPropagation();
                      }}
                      title={option?.saleAttribute?.color || ''}
                    >
                      <ImageWithSkeleton
                        src={handleImgUrl(
                          Global.imageUrl! +
                          handleUrlSpecialChar(
                            option?.images?.whiteBackPic[0],
                          ),
                          "200x200",
                        )}
                        width={36}
                        height={36}
                        alt={props.product}
                        isButton={true}
                      />
                    </div>
                  );
                })
                : false}
            </div> : null
          }

          {/* {isIcon && (
            <div className="mt-10 flex space-x-8">
              <FSC width={iconSize} />
              <BEC width={iconSize} />
              <GreenGuard width={iconSize} />
            </div>
          )} */}
        </div>
      ) : (
        <div className="mt-16">
          <span className="text-lg text-bravve-100 underline">
            View details
          </span>
        </div>
      )}
    </div>
  );
};
